# Ask permission before adding authors to this file, it's polite!
# Omit authors from this list if they would rather be anonymous.

Costa Primo:
  authorUrl: https://www.youtube.com/channel/UCC1yHilnsxIy4wIgflg-pXw

'[NA] Crone':
  authorUrl: https://www.youtube.com/channel/UCUx_JZ1pQFkbIH-KtOUPKgA

Fennec:
  authorUrl: https://www.youtube.com/channel/UCiBaiZgGE0M8lrg_xIVor2A

Fines:
  authorUrl: https://www.youtube.com/channel/UCGg3-vKGC8amnpkli7i_qTQ

Incera:
  authorUrl: https://www.youtube.com/channel/UC6K-mvcADSGSXcvhcxvHYhQ

Iskarel:
  authorUrl: https://www.youtube.com/channel/UCUVtCgtHzAQzdZL2cKrxfNA

'[Aves] Leder':
  authorUrl: https://www.youtube.com/channel/UC1tugO9R0bDZk60OEMZ2GgA

Left:
  authorUrl: https://www.youtube.com/channel/UCj-iaC7tUKWh3XlmPA0g6TQ

Ryan:
  authorUrl: https://www.youtube.com/channel/UCOo_7XVLMH2-s80ZIBMc4qg

REMagic:
  authorUrl: https://www.youtube.com/channel/UCA2rppcdbx1a2CQxS6BqwMQ

Support Hero:
  authorUrl: https://www.youtube.com/channel/UChXnJbnYK_j3h9689UtKAyg

'[CnD] Aphrodite Lady':
  authorUrl: https://www.youtube.com/channel/UC5pvam7aCn2A8QbDMn2rOhw

'[CnD] Bekko':
  authorUrl: https://www.youtube.com/channel/UCe7Wkk8PxtLRRn-p5SXaU1w

'[CnD] DaedDee':
  authorUrl: https://www.youtube.com/channel/UCHqq81PPmc7A1iQQ3JApUuA

'[CnD] Lunar':
  authorUrl: https://www.youtube.com/channel/UCLAQLxxF_RIXr_ggFzW6M2A

'[CnD] Tipcat':
  authorUrl: https://www.youtube.com/channel/UC3d0AKF75J8FaqyV9JyEWxg

'[CnD] Xyonon':
  authorUrl: https://www.youtube.com/channel/UC8JHT0vruIu7jesAqJVadeA

'[Inn] Xorxy':
  authorUrl: https://www.youtube.com/channel/UC89Ez6t-l4BTlePkSEkgNCg

Snow Crows: {}

'[SC] Luna':
  authorUrl: https://www.youtube.com/channel/UCfWxpxdyWiyC2pm-XFxn7Jw

'[SC] Roul':
  authorUrl: https://www.youtube.com/channel/UCXhVSyj7F7zIkQzcISynA7A

'[SC] Westet':
  authorUrl: https://www.youtube.com/channel/UCXXWbTvk_eLahxOrExqMrVw

'[XVII] ster':
  authorUrl: https://www.youtube.com/channel/UCIceQJPuG3CRnt4xnczTE2g

'[dT/XVII] Seatek':
  authorUrl: https://www.youtube.com/channel/UC8L6s_rOwVdzO6oW8gABfDQ

Masel:
  authorUrl: https://www.youtube.com/channel/UChVEG6ckuAgGs5OyA6VeisA

Umbra:
  authorUrl: https://www.youtube.com/channel/UCHoDEpImiHVcImNabrvd9wg

Luxroy:
  authorUrl: https://www.youtube.com/channel/UCBkFAcXCOCL4UvSgEW_0WQA

'[Vs] Nico':
  authorUrl: https://www.youtube.com/channel/UCYi2lmZ-yl4qw38OdQTtaFw

'[SC] Obvious Trash':
  authorUrl: https://www.youtube.com/channel/UClxCenVE9f_59CVNc5F5K_Q

'beng / L3m0n':
  authorUrl: https://www.youtube.com/channel/UC-9uRHJIbzXf_EAZq7l0MeQ

'Baym':
  authorUrl: https://www.youtube.com/channel/UCBeQ3pDAmg08ecPfk7RSWoA

'vpo':
  authorUrl: https://www.youtube.com/channel/UCHTtUZf8ZZjkVaNr10pkCUA

'Pufin':
  authorUrl: https://www.youtube.com/channel/UCn7o2nKD5LqTmcxlPuuNYMg

'Dánmander':
  authorUrl: https://www.youtube.com/channel/UC0rNcgH1ti8_4a0lj6W7Asw

'[InS] Laoshi':
  authorUrl: https://www.youtube.com/channel/UC4EYbGXqdccCiH6rVZSjqxA

Baseraver:
  authorUrl: https://www.youtube.com/channel/UCEbKKnsC5ISYlFBFAptb6WA

Evo:
  authorUrl: https://www.youtube.com/channel/UCEzsGOumJ6axbGTRtkFkEBg

DaniDomum:
  authorUrl: https://www.youtube.com/channel/UCCqG4Gz7gs03wnGpY-M5i9w

'[SC] Fallen':
  authorUrl: https://www.youtube.com/channel/UCmrnQs0M60R_tOehC9W43rQ

FidelOo:
  authorUrl: https://www.youtube.com/channel/UCusT-ZA_YgFYI3zFehssgAw

Zargholl:
  authorUrl: https://www.youtube.com/channel/UCf_N9VN9kMgx1fJzVr6Nxew

Cody:
  authorUrl: https://www.youtube.com/channel/UCtrfUYY7wdV2cVix96RBeDA

Sarulias:
  authorUrl: https://www.youtube.com/channel/UC6WW579EGk6r8A4a1i-7hSw

Derm:
  authorUrl: https://www.youtube.com/channel/UCDyH5t5zp3NSSG3LHJAYiSA

Aralyth:
  authorUrl: https://www.youtube.com/channel/UCMrXgR9YLaML6zFAg4jqmYw

Jan:
  authorUrl: https://www.youtube.com/channel/UC9NQMVg0qSrue8_cjmBRPBA

Mastro:
  authorUrl: https://www.youtube.com/channel/UCZ2pHxaE4q--0LBU7aGDPJw

'[SC] Trace':
  authorUrl: https://www.youtube.com/channel/UC32EihhZG2lNEeU1KhhanRA

Shavy:
  authorUrl: https://www.youtube.com/channel/UCpJGHEg4ASvCBE1Nf7oQh5Q

Andy:
  authorUrl: https://www.youtube.com/channel/UCmbnS1viSQM5xgohZ0EsohA

Pip:
  authorUrl: https://www.youtube.com/channel/UCFlLOubKTF7WAGVnIrmR3vw

Ostro:
  authorUrl: https://www.youtube.com/@Saturnity

Tiramichu:
  authorUrl: https://www.youtube.com/@cepheus4082

Cemox:
  authorUrl: https://www.youtube.com/@cemox2844

'Saint Mighty':
  authorUrl: https://www.youtube.com/@SntMighty

Linsi:
  authorUrl: https://www.youtube.com/@linsiana

Botinator:
  authorUrl: https://www.youtube.com/@botinator155

'[LCs] Seisan':
  authorUrl: https://www.youtube.com/@Seisan-gw2

Black:
  authorUrl: https://www.youtube.com/@Blackbupf

Kadenar:
  authorUrl: https://www.youtube.com/@Kadenar

Alcatraz:
  authorUrl: https://www.youtube.com/@AlcatrazGW2

Maragon:
  authorUrl: https://www.youtube.com/@maragonmh2674

'jkerkhoven':
  authorUrl: https://www.youtube.com/@jkerkhoven

EDLR:
  authorUrl: https://www.youtube.com/@ExtarDeLaRochebriant

Arzon:
  authorUrl: https://www.youtube.com/@Arzon-p4q

Yurugani:
  authorUrl: https://www.youtube.com/@Yurugani

'[LN] Toilet':
  authorUrl: https://www.youtube.com/@PigeonGw2

Rumi:
  authorUrl: https://www.youtube.com/@73Days

Sotym:
  authorUrl: https://www.youtube.com/@MCASotym

Chimera:
  authorUrl: https://www.youtube.com/channel/UCSc1F9n90zY4kPiC-OBjlsg

Lyco:
  authorUrl: https://www.youtube.com/channel/UCQR8cfbpjSGho1Xp2e6fqig

Jul Nine:
  authorUrl: https://www.youtube.com/channel/UCDNcnGO9Wlypps67bKn2AcA

'[CRS] Rainer':
  authorUrl: https://www.youtube.com/channel/UCXwhB1Jf8R6Dovd7BDboXWg

Trufla:
  authorUrl: https://www.youtube.com/channel/UCvtAhwXnYZ0XMfLiUA0TVOQ

Kartky:
  authorUrl: https://www.youtube.com/channel/UClaYG-heGJVWqdBk_UND5zw

'mayo [cA]':
  authorUrl: https://www.youtube.com/channel/UCl9gyCBfkre4ZRV1qgW70rw

Florian:
  authorUrl: https://www.youtube.com/channel/UCYztkC8W2IUrzKqX-9-Zieg

Limelight:
  authorUrl: https://www.youtube.com/channel/UC6hiyXhP97rdlmIcMErOjqQ

DingoUndSo:
  authorUrl: https://www.youtube.com/channel/UCPUlTDFhAwJIeDkY2AfKPAQ
